// src/components/Home.js
import React from 'react';
import { Container, Typography, Card, CardContent, Box } from '@mui/material';

function Home() {
  const rol = localStorage.getItem('rol');

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Card sx={{ boxShadow: 4, borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            🚚 Bienvenido a ProSM Logistic - LoginTrack
          </Typography>

          {rol ? (
            <Typography variant="body1" sx={{ mb: 2 }}>
              Hola {rol === 'admin' ? 'Administrador' : 'Cliente'}, accede a tu panel para gestionar o consultar envíos.
            </Typography>
          ) : (
            <Typography variant="body1" sx={{ mb: 2 }}>
              Por favor, inicia sesión o regístrate para continuar.
            </Typography>
          )}
        </CardContent>
      </Card>

      {/* Footer sencillo */}
      <Box
        sx={{
          mt: 4,
          py: 2,
          textAlign: 'center',
          borderTop: '1px solid #ddd',
          color: 'text.secondary'
        }}
      >
        <Typography variant="body2">
          © {new Date().getFullYear()} ProSM Logistic - LoginTrack — Envíos marítimos, aéreos y terrestres
        </Typography>
      </Box>
    </Container>
  );
}

export default Home;